import { CheckCircle, X } from 'lucide-react';

export function getWeekRange(offset = 0) {
  const now = new Date();
  const day = now.getDay(); // 0=Sun
  const monday = new Date(now);
  monday.setDate(now.getDate() - (day === 0 ? 6 : day - 1) + offset * 7);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  const fmt = d => d.toISOString().split('T')[0];
  return { start: fmt(monday), end: fmt(sunday), label: `${fmt(monday)} – ${fmt(sunday)}` };
}

const RATING_WEIGHTS = { good: 1, average: 0.5, needs_improvement: 0 };

// Score out of 5: up to 2 for on-time/late completion, up to 3 for the
// three teacher-set rating dimensions (handwriting/spelling/neatness).
export function submissionScore(sub) {
  if (!sub) return 0;
  const completionScore = sub.status === 'completed' ? 2 : sub.status === 'late' ? 1 : 0;
  const ratingScore = ['handwriting', 'spelling', 'neatness']
    .reduce((s, k) => s + (RATING_WEIGHTS[sub[k]] ?? 0), 0);
  return Math.round(completionScore + ratingScore);
}

// Stacked per-cell display: rating out of 5, a short feedback summary, then
// the tick/cross completion mark.
export function SubmissionCell({ sub }) {
  const done = sub?.status === 'completed';
  const score = submissionScore(sub);
  const summary = sub?.remarks || (sub ? 'No remarks yet' : 'Not marked yet');
  return (
    <div className="flex flex-col items-center gap-1">
      <span className={`text-[11px] font-bold ${score >= 4 ? 'text-green-600' : score >= 2 ? 'text-amber-600' : 'text-red-500'}`}>
        {score}/5
      </span>
      <span className="text-[9px] text-gray-500 max-w-[78px] truncate" title={summary}>{summary}</span>
      {done
        ? <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-green-100"><CheckCircle size={13} className="text-green-600" /></span>
        : <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-red-50"><X size={13} className="text-red-500" /></span>
      }
    </div>
  );
}
